export const PLATFORMS = [
  "LinkedIn", "Instagram", "Facebook", "X (Twitter)", "Email List",
  "Substack", "YouTube", "Mixed / Omnichannel",
];

export const AWARENESS_STAGES = [
  { value: "cold", label: "Cold", description: "Doesn't know me yet" },
  { value: "warm", label: "Warm", description: "Aware of me, not convinced" },
  { value: "hot", label: "Hot", description: "Knows me, considering buying" },
];

export const LOADING_MESSAGES = [
  "Mapping the sequence arc...",
  "Designing each piece...",
  "Building the progression logic...",
  "Connecting the bridges...",
];
